import { Controller } from "@hotwired/stimulus"

// Gates an Aged Inventory "Move oldest" form: the submit stays disabled until
// the count (N) is a positive integer, and is cleared + re-disabled once the
// form has fired (turbo:submit-end), so the control starts clean for the next
// move. The action redirects, so the page reloads on success too — this just
// keeps the button inert immediately and never enables it on an empty/invalid N.
export default class extends Controller {
  static targets = ["count", "submit"]

  connect() {
    this.validate()
  }

  // Enable Move oldest only when count is a positive integer.
  validate() {
    const value = this.countTarget.value.trim()
    const valid = /^\d+$/.test(value) && parseInt(value, 10) > 0
    this.submitTarget.disabled = !valid
  }

  // After the form fires, blank N and disable the button (re-validates to do so).
  reset() {
    this.countTarget.value = ""
    this.validate()
  }
}
